import styled from 'styled-components';

import {
  BodySmallMedium,
  BodySmallRegular,
  BodyStandardSemiBold,
  Colour,
  MinBreakpointV2,
} from '@xemplo/style-constants';

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Group = styled.section`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const GroupTitle = styled.div`
  ${BodyStandardSemiBold};
  color: ${Colour.Gray[800]};
  margin: 0;
`;

export const GroupCard = styled.div`
  border: 1px solid ${Colour.Gray[200]};
  border-radius: 8px;
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;

  @media ${MinBreakpointV2.medium} {
    grid-template-columns: 272px 1fr 1fr;
  }
`;

export const RowDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const RowLabel = styled.span`
  ${BodySmallMedium};

  color: ${Colour.Gray[800]};
`;

export const RowCurrent = styled.span`
  ${BodySmallRegular};
  color: ${Colour.Gray[500]};
  display: flex;
  align-items: center;
  gap: 8px;
`;
export const Banners = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
